type ResizeEvent = {
  breakpoint: string;
  height: number;
  type: 'resize';
  width: number;
};

type ResponsiveContainerOptions = {
  breakpoints?: string[];
  defaultBreakpoint?: string;
  onResize?: (event: ResizeEvent) => void;
};

export const isResizeEvent = (event: any): event is ResizeEvent =>
  typeof event === 'object' &&
  typeof event.breakpoint === 'string' &&
  typeof event.height === 'number' &&
  event.type === 'resize' &&
  typeof event.width === 'number';

export const setUpResponsiveContainer = (
  containerSelector: string,
  options: ResponsiveContainerOptions = {},
) => {
  if (typeof containerSelector !== 'string') {
    throw new Error(
      `FLMPiano.setUpResponsiveContainer expects the first argument to be a string, received: ${JSON.stringify(
        containerSelector,
      )}`,
    );
  }
  let container = document.querySelector(containerSelector);

  const breakpoints = options.breakpoints || [
    'extraSmall',
    'small',
    'medium',
    'large',
  ];
  const defaultBreakpoint = options.defaultBreakpoint || breakpoints[0];
  const { onResize } = options;

  const isBreakpointName = (value: string) => breakpoints.indexOf(value) >= 0;

  const handleMessage = (messageEvent: MessageEvent) => {
    if (
      typeof messageEvent !== 'object' ||
      typeof messageEvent.data !== 'object'
    ) {
      return;
    }

    const { data: message } = messageEvent;
    if (typeof message !== 'object') {
      return;
    }

    const { event } = message;
    if (isResizeEvent(event)) {
      handleParentResize(event);
      return;
    }
  };

  const handleParentResize = (event: ResizeEvent) => {
    setBreakpoint(event.breakpoint);

    if (typeof onResize === 'function') {
      onResize(event);
    }
  };

  const setBreakpoint = (breakpoint: string) => {
    container = container || document.querySelector(containerSelector);
    if (!container) {
      return;
    }

    container.className = container.className
      .split(/\s+/)
      .filter((className) => !isBreakpointName(className))
      .concat([breakpoint])
      .join(' ');
  };

  setBreakpoint(defaultBreakpoint);

  window.addEventListener('message', handleMessage, false);
};
